import { paymentsApi } from '.';

export interface PaypalExecuteRequest {
  client: string,
  transactionId: string,
  account_identifier: string,
  paymentId: string,
  payerId: string,
}

export interface PaypalExecuteResponse {
  data: { firstName?: string },
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    paypalExecute: builder.mutation<PaypalExecuteResponse, PaypalExecuteRequest>({
      query: body => ({
        url: 'provider/paypal/execute',
        method: 'POST',
        body,
      })
    })
  })
});

export const { usePaypalExecuteMutation } = extendedPaymentsApi;
